module.exports = __webpack_public_path__ + "static/img/20018 (1).4f2eb39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20018 (1).jpg
// module id = jcZi
// module chunks = 14